<template>
  <div>
    <el-row>
      <el-col :span="24">
        <el-button
          style="padding: 0; margin: 20px"
          type="text"
          icon="el-icon-back"
          @click="goBack()"
        >
          返回
        </el-button>
        <el-button type="primary" size="mini" @click="exportOrder()">
          导出
        </el-button>
      </el-col>
    </el-row>

    <el-row>
      <el-table
        v-loading="loading"
        :data="list"
        border
        size="mini"
        :stripe="true"
        style="width: 100%; margin: 20px 0"
      >
        <el-table-column
          prop="id"
          label="订单ID"
          align="center"
          min-width="5%"
        ></el-table-column>
        <el-table-column
          prop="nickname"
          label="昵称"
          align="center"
          min-width="5%"
        ></el-table-column>
        <el-table-column
          prop="agent_name"
          label="用户归属"
          align="center"
          min-width="5%"
        ></el-table-column>
        <el-table-column
          prop="event_nickname"
          label="订单导购"
          align="center"
          min-width="5%"
        ></el-table-column>
        <el-table-column
            prop="body"
            label="内容"
            align="center"
            min-width="5%"
        ></el-table-column>
        <el-table-column
            prop="total_amount"
            label="订单价格"
            align="center"
            min-width="5%"
        ></el-table-column>
        <el-table-column
          prop="order_no"
          label="订单号"
          align="center"
          min-width="5%"
        ></el-table-column>
        <el-table-column
          prop="order_sub_nos"
          label="子订单"
          align="center"
          min-width="5%"
        ></el-table-column>
        <el-table-column
          prop="status_name"
          label="状态"
          align="center"
          min-width="5%"
        ></el-table-column>
        <el-table-column
          prop="pay_total_amount"
          label="实付金额"
          align="center"
          min-width="5%"
        ></el-table-column>
        <el-table-column
          prop="paid_at"
          label="支付时间"
          align="center"
          min-width="5%"
        ></el-table-column>
        <el-table-column
          prop="total_refund_amount"
          label="退款金额"
          align="center"
          min-width="5%"
        ></el-table-column>
        <el-table-column
            prop="updated_at"
            label="退款时间"
            align="center"
            min-width="5%"
        ></el-table-column>
        <el-table-column
          label="是否计算业绩"
          align="center"
          min-width="12%"
          class-name="performance-switch-column"
          v-if="this.transaction_type == 'refunds' && this.channel_type != '3' && !(this.channel_type == '1' && this.type == '5')"
        >
          <template slot-scope="scope">
            <div class="performance-switch-wrapper">
              <el-switch
                v-model="scope.row.is_affect_performance"
                active-text="计业绩"
                inactive-text="不计业绩"
                @change="handlePerformanceToggle(scope.row)"
                :active-color="'#67c23a'"
                :inactive-color="'#909399'"
                :active-value="1"
                :inactive-value="0"

                :loading="scope.row.updating"
                style="--el-switch-on-color: #67c23a; --el-switch-off-color: #909399; transition: all 0.3s ease;"
              ></el-switch>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          label="操作"
          align="center"
          min-width="10%"
          fixed="right"
          v-if="this.channel_type == '3' ||(this.channel_type == '1' && this.type == '5')"
        >
          <template slot-scope="scope">
            <el-button
              type="danger"
              size="mini"
              @click="handleDelete(scope.row)"
              :loading="scope.row.deleting"
            >
              删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-row>
    <el-row>
      <div class="block">
        <el-pagination
          background
          @current-change="getList"
          :current-page.sync="query.page"
          :page-size="query.limit"
          layout="total, prev, pager, next, jumper"
          :total="total"
        >
        </el-pagination>
      </div>
    </el-row>
  </div>
</template>

<script>
import { getOrderList,getOperationOrderList,changeIsAffectPerformance,getSalonOrderList,deletePerformanceStatisticsOrder } from "@/api/channel";
const axios = require('axios');

export default {
  data: function () {
    return {
      list: [],
      loading: false,
      total: 0,
      headerTitle: this.$route.query.headerTitle,
      transaction_type: this.$route.query.transaction_type,
      channel_type: this.$route.query.channel_type,
      type: this.$route.query.type,
      query: {
        page: 1,
        limit: 20,
        is_export:0
      },
    };
  },
  created: function () {
    this.getList();
  },
  mounted() {},
  methods: {
    getList() {
      this.loading = true;
      console.log(this.$route.query)
      Object.assign(this.query,this.$route.query)
      if(this.channel_type === '1'){
        getOrderList(this.query).then((response) => {
          this.list = response.data.list;
          this.total = response.data.total;
          this.loading = false;
        });
      }else if(this.channel_type === '2'){
        getOperationOrderList(this.query).then((response) => {
          this.list = response.data.list;
          this.total = response.data.total;
          this.loading = false;
        });
      }else if(this.channel_type === '3'){
        getSalonOrderList(this.query).then((response) => {
          this.list = response.data.list;
          this.total = response.data.total;
          this.loading = false;
        });
      }

    },
    exportOrder() {
      this.query.is_export = 1;
      Object.assign(this.query,this.$route.query)
      var urlTo = '';
      if(this.channel_type === '1' || this.channel_type === '3'){
        urlTo = "/backend/statistics/channel/orderList";
      }else if(this.channel_type === '2'){
        urlTo = "/backend/statistics/channel/operations/order/list";
      }
      /*if (this.query.is_export > 0) {*/
        axios({
          method: "post",
          url: urlTo,
          data: this.query,
          responseType: "blob",
        })
      /*getOrderList(this.query)*/.then((res) => {
            //console.log(res)
            const link = document.createElement("a");
            let blob = new Blob([res.data], {
              type: "application/vnd.ms-excel",
            });
            link.style.display = "none";
            link.href = URL.createObjectURL(blob);
            link.setAttribute("download", "渠道业绩统计-订单明细.xls");
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            this.query.is_export = 0;
          })
          .catch((error) => {
            this.$Notice.error({
              title: "错误",
              desc: "网络连接错误",
            });
            console.log(error);
          });
      /*}*/
    },
    goBack(){
      /*this.$router.push({
        path: "/statistics/channel",
        query: this.$route.query
      });*/
      localStorage.setItem('month', this.$route.query.month)
      localStorage.setItem('channel_type', this.$route.query.channel_type)
      this.$router.go(-1)
    },
    
    handlePerformanceToggle(row) {
      // 记录原状态，用于错误时恢复
      const originalStatus = row.is_affect_performance;
      const newStatus = row.is_affect_performance;
          
      // 添加行级加载状态，避免整个表格显示加载
      row.updating = true;
          
      // 调用后端 API 更新状态
      axios({
        method: 'post',
        url: '/backend/statistics/channel/changeIsAffectPerformance',
        data: {
          order_id: row.id,
          is_affect_performance: newStatus
        }
      }).then((response) => {
        row.updating = false;
            
        if (response.data.status === "2000" || response.data.code === 1) {
          // 使用更简洁的成功提示
          this.$message.success('状态更新成功');
        } else {
          // 恢复原状态
          row.is_affect_performance = originalStatus;
          this.$message.error(response.data.message || response.data.msg || '更新失败，请稍后重试');
        }
      }).catch((error) => {
        // 恢复原状态
        row.is_affect_performance = originalStatus;
        row.updating = false;
        this.$message.error('网络错误，请稍后重试');
        console.error('更新业绩状态失败:', error);
      });
    },
        
    /**
     * 删除订单
     * @param {Object} row - 订单数据行
     */
    handleDelete(row) {
      this.$confirm('确认删除该订单吗？此操作不可恢复！', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        // 添加行级加载状态
        row.deleting = true;
            
        // 调用删除 API
        deletePerformanceStatisticsOrder({
          order_id: row.id
        }).then((response) => {
          console.log(response);
          row.deleting = false;
              
          if (response.status === "2000" || response.code === 1) {
            this.$message.success('删除成功');
            // 从列表中移除该订单
            this.list = this.list.filter(item => item.id !== row.id);
            // 更新总数
            this.total--;
          } else {
            this.$message.error(response.message || response.msg || '删除失败，请稍后重试');
          }
        }).catch((error) => {
          row.deleting = false;
          this.$message.error('网络错误，请稍后重试');
          console.error('删除订单失败:', error);
        });
      }).catch(() => {
        // 用户取消删除，不做任何处理
      });
    }
  },
};
</script>

<style scoped>
/* 美化操作列 */
:deep(.performance-switch-column .el-table__cell) {
  padding: 12px 0;
  display: flex;
  justify-content: center;
  align-items: center;
}

/* 开关容器样式 */
.performance-switch-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 4px 8px;
  border-radius: 6px;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  position: relative;
}

/* 美化开关文本样式 */
:deep(.el-switch__label) {
  font-size: 12px;
  font-weight: 500;
  padding: 0 6px;
  transition: color 0.3s ease;
}

:deep(.el-switch__label--left) {
  color: #606266;
}

:deep(.el-switch__label--right) {
  color: #67c23a;
}

/* 鼠标悬停效果 */
.performance-switch-wrapper:hover {
  background-color: #f5f7fa;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  transform: translateY(-1px);
}

/* 开关切换动画优化 */
:deep(.el-switch) {
  font-size: 12px;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

:deep(.el-switch__core) {
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

/* 开关滑块动画 */
:deep(.el-switch__core::after) {
  transition: transform 0.3s cubic-bezier(0.4, 0, 0.2, 1), 
              width 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

/* 加载状态样式 */
:deep(.el-switch.is-loading .el-switch__core) {
  opacity: 0.8;
}

/* 禁用状态优化 */
:deep(.el-switch.is-disabled) {
  opacity: 0.7;
}

/* 点击反馈效果 */
.performance-switch-wrapper:active {
  transform: translateY(0);
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

/* 优化文本与开关的间距 */
:deep(.el-switch__label-wrapper) {
  transition: margin 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}
</style>